import { render } from "./write.vue?vue&type=template&id=7f9864f7&scoped=true"
import script from "./write.vue?vue&type=script&lang=js"
export * from "./write.vue?vue&type=script&lang=js"

import "./write.vue?vue&type=style&index=0&id=7f9864f7&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f9864f7"]])

export default __exports__